var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
/**
 * This service is used to create ordinal numbers (eg 1st, 2nd, 3rd) from cardinal numbers (eg 1, 2, 3).
 * It uses Javascript's Intl.PluralRules, which is based on the CLDR rules:
 * https://unicode-org.github.io/cldr-staging/charts/37/supplemental/language_plural_rules.html
 */
let IntlOrdinal = (_class = class IntlOrdinal extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  fromCardinal(cardinal) {
    const pluralRules = new Intl.PluralRules(this.intl.locale, {
      type: 'ordinal'
    });
    const ruleForCardinal = pluralRules.select(cardinal);
    const translationKey = {
      few: 'common.ordinal.few',
      many: 'common.ordinal.many',
      one: 'common.ordinal.one',
      other: 'common.ordinal.other',
      two: 'common.ordinal.two',
      zero: 'common.ordinal.zero'
    }[ruleForCardinal];
    return this.intl.t(translationKey, {
      cardinal
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { IntlOrdinal as default };